import { Table, TableProps } from "antd";
import dayjs from "dayjs";
import { DataType } from "../../../models/interface/license.interface";
import { ColumnsActivated } from "./Column";
import PaginationComponent from "./Pagination";

const App = ({
  data,
  total,
  rowSelection,
  currentPage,
  pageSize,
  requestedAtSortOrder,
  onTableChange,
}: {
  data: DataType[];
  total: number;
  rowSelection: TableProps<DataType>["rowSelection"];
  currentPage: number;
  pageSize: number;
  requestedAtSortOrder: "ascend" | "descend" | null;
  onTableChange: TableProps<DataType>["onChange"];
}) => {
  return (
    <div className="border border-solid border-[#EBEEF2] rounded-lg">
      <Table<DataType>
        columns={ColumnsActivated(
          currentPage,
          pageSize,
          total,
          requestedAtSortOrder,
        )}
        dataSource={data}
        rowSelection={rowSelection}
        pagination={false}
        rowKey={(record) => record.id?.toString() ?? ""}
        className="custom-table"
        scroll={{ x: 1600 }}
        tableLayout="fixed"
        onChange={onTableChange}
        rowClassName={(record) => {
          if (!record.expiresAt) return "";
          const isNearExpiry =
            dayjs(record.expiresAt).diff(dayjs(), "day") < 90;
          return isNearExpiry ? "row-over-limit" : "";
        }}
        locale={{
          triggerAsc: "クリックして昇順にソート",
          triggerDesc: "クリックして降順にソート",
          cancelSort: "クリックしてソートを解除",
        }}
      />
      <PaginationComponent total={total} />
    </div>
  );
};

export default App;
